/**
 * Trending API: country-level (home page) and society-level (society page).
 * Data is manually curated for revenue placements.
 */
import api from './api/axiosConfig';

const trendingService = {
  /**
   * Get country trending items (businesses) for the home page.
   * @returns {Promise<{ results: Array<{ id, position, business_data }> }>}
   */
  getCountryTrending: async () => {
    const response = await api.get('/trending/country/');
    const data = response.data?.data ?? response.data;
    return data?.results ?? data ?? [];
  },

  /**
   * Get society trending items (businesses) for a society page.
   * @param {string|number} societyId - Society ID or slug
   * @returns {Promise<Array<{ id, position, business_data }>>}
   */
  getSocietyTrending: async (societyId) => {
    if (societyId == null || societyId === '') return [];
    const response = await api.get(`/trending/society/${encodeURIComponent(societyId)}/`);
    const data = response.data?.data ?? response.data;
    return data?.results ?? data ?? [];
  },
};

export default trendingService;
